import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminSupportTicketsList } from "./use-duvi-core-admin-support-tickets-list";
import { DuviCoreAdminSupportTicketsListView } from "./duvi-core-admin-support-tickets-list-view";

export function DuviCoreAdminSupportTicketsList() {
  const state = useDuviCoreAdminSupportTicketsList();

  return (
    <DuviCoreAdminAppShell
      title="Support tickets"
      subtitle="Every ticket across the platform"
      breadcrumbs={["Support", "Tickets"]}
      activeMenuItem="Support"
    >
      <DuviCoreAdminSupportTicketsListView {...state} />
    </DuviCoreAdminAppShell>
  );
}
